export default {
    common:{
        dateFormat: "DD.MM.YYYY",
        currency:  "CHF {value}",
        choose:     "Choose",
        next:       "Continue",
        previous:   "Back",
        bestChoice: "Best choice",
        and:        "and",
        or:         "or",
        edit:       "Change",
        basket:     "Basket",
        yourStudio: "Your club",
        yourPlan:   "Your membership",
        yourAddition: "Your extras",
        noAddition: "Continue without extras",
        opening: "Opening {date}"
    },
    widget:{
        studio:{
            searchPlaceholder: "Search by post code or city",
            clubList: "Clublist",
            mapView: "Map view",
        },
        basket:{
            totalAmount: "Total",
        },
        user:{
            genderFemale: "Female",
            genderMale: "Male",
            genderDivers: "Other",
            firstname: "First Name",
            lastname: "Last Name",
            email: "E-Mail",
            phone: "Telephone number",
            birthday: "Date of Birth",
        },
        address:{
            street: "Street",
            streetno: "Number",
            zipcode: "Postcode",
            city: "City",
            country: "Country",
        },
        membership:{
            membership: "Subscription",
            startOfMembership: "Starting date of membership",
            trainingsStart: "Start training from {date}",
            rightAway: "now",
        }
    },
    footer:{
        backToHomepage: "Back to Website",
        imprint: "Legal notice",
        dataProtection: "Privacy statement",
        paymentOptions: "Payment options",
    },
    steps: {
        step1_1: 'Choose a club',
        step1_2: 'Choose subscription',
        step1_3: 'Choose extras',
        step1_4: 'Summary',
        step2_1: 'Personal Details',
        step2_2: 'Address',
        step2_3: 'Payment',
        step2_4: 'Check-Out',
    },
    pages:{
        selectClub:{
            headline: "Choose your Club",
        },
        selectContract: {
            headline: "Choose subscription",
            choosePlan: "Choose your subscription",
            chooseRuntime: "Choose your subscription length",
            basisPlan: "Our Core offering",
            premiumPlan: "Our Premium offering",
            planPoints: [
                "Basefit app incl. live visitors data available",
                "Live Group Fitness On-Demand",
                "Access to all clubs",
                "Your friend trains for free on the weekend",
                "No notice period",
                "Freeze your membership",
                "Joining Fee",
                "Monatlich kündbar",
            ]
        },
        selectAddition:{
            headline: "Make your membership complete",
            unselectAddition: "Continue without extras",
        },
        overview:{
            headline: "Your overview",
            yourData: "Your details",
        },
        selectData:{
                dataProtection: "Data Protection",
                checkboxDataPolice: "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam {DP_URL}.",
                checkboxNewsletter: "Yes I would like to receive marketing information and information about other products from basefit.ch and its partners.",
                footerActionText: "Please fill in",
                yourData: "Your details",
            },
        selectAddress:{
                yourAddress: "Your address",
                yourMembership: "Membership",
                howDoYouKnow: "Where do you know us from?",
                footerName: "Hello {fname}",
                footerActionText: "Please state here your address",
            },
            selectPayment:{
                yourPaymentOptions: "Your payment options",
                healthInsuranceRefund: "health insurance reimbursement",
                checkboxHealthInsuranceRefund: "yes i would like to take advantage of the bonus program - up to CHF 527.25 refund – and to be contacted for this. I consent to the transfer of my data to Swica. You can find more information here {url}.",
                checkboxUrlText: "here",
            },
        checkOut:{
            yourOverview: "Your overview",
            yourData: "Your details",
            address: "Address",
            yourMembershipStart: "Your membership start",
            paymentInformation: "Payment information",
            couponRedeem:  "Use",
            coupon:    "Vouchercode",
            couponAccept: "Your vouchercode {coupon} has been accepted.",
            couponDecline: "Your vouchercode {coupon} has not been accepted.",
            orderForFee: "Pay",
            checkboxAGB: "I agree to the {url_agb} and the {url_dataprotection} of basefit.ch.",
            checkboxURLAGB: "AGB",
        },
    },
};